var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import { resolveFileUrl } from "./../../ricos-media";
import { AUDIO_TYPE, FILE_UPLOAD_TYPE, VIDEO_TYPE } from "./../../wix-rich-content-common";
const getVideoUrl = (src) => `https://video.wixstatic.com/${src.pathname}`;
const getThumbnailUrl = (src) => {
  if (src.pathname.startsWith("media/")) {
    return `https://static.wixstatic.com/${src.pathname}`;
  }
  return `https://static.wixstatic.com/media/${src.pathname}`;
};
const getAudioUrl = (src) => `https://static.wixstatic.com/${src.id}`;
function urlResolutionStrategy(hasPlugin, instance, metaSiteId, _experiments) {
  if (!metaSiteId) {
    return { config: {} };
  }
  return {
    config: __spreadValues(__spreadValues(__spreadValues({}, hasPlugin(VIDEO_TYPE) && {
      [VIDEO_TYPE]: {
        getVideoUrl,
        getThumbnailUrl
      }
    }), hasPlugin(AUDIO_TYPE) && {
      [AUDIO_TYPE]: {
        getAudioUrl
      }
    }), hasPlugin(FILE_UPLOAD_TYPE) && metaSiteId && {
      [FILE_UPLOAD_TYPE]: {
        resolveFileUrl: resolveFileUrl(metaSiteId, instance)
      }
    }),
    helpers: {
      getImageUrl({ file_name }) {
        return `https://static.wixstatic.com/media/${file_name}`;
      }
    }
  };
}
export {
  urlResolutionStrategy as default
};
//# sourceMappingURL=urlResolutionStrategy.js.map
